import React, { useEffect, useRef, useState } from "react";
import { useSelector } from "react-redux";
import $ from 'jquery-slim';

import { ArticleButton } from "../../pages/Widgets/Helper";
import ReadTime from "../ReadTime";
import ModalBase from "../DialogBox/ModalBase";
import Background from "../Background";
import ArticleSave from "../ArticleSave";
import CategoryList from "../CategoryList";

import style from "./style.module.css";

function Hover(props) {
    const userProfile = useSelector((state) => state.storage.data);
    const {
        itemRef,
        closeModal,
        id,
        thumbnail_image,
        media_type,
        url,
        time_duration,
        themes = [],
        categories = [],
        tags = []
    } = props;
    const ref = useRef(null);

    const [openClass, setOpenClass] = useState('');
    const [closeClass, setCloseClass] = useState('');
    const unhoverTimer = useRef(null);
    const hoverClose = useRef(null);

    useEffect(() => {
        let timer = setTimeout(() => {
            setOpenClass(" " + style.show);
        }, 50);

        const handleClickOutside = (e) => {
            e.stopPropagation();
            if (ref.current.contains(e.target)) {
                return false;
            }
            unhoverTimer.current = setTimeout(() => {
                setCloseClass(" " + style.hide);
                hoverClose.current = setTimeout(() => {
                    closeModal();
                }, 500);
            }, 500);
        };

        document.addEventListener('mousemove', handleClickOutside);

        return () => {
            document.removeEventListener('mousemove', handleClickOutside);
            clearTimeout(timer);
            if (unhoverTimer.current) clearTimeout(unhoverTimer.current);
            if (hoverClose.current) clearTimeout(hoverClose.current);
        };
    }, [closeModal]);

    const offsetStyling = () => {
        let current_node = itemRef.current;
        if (current_node) {
            return {
                top: ($(current_node).offset().top + $(current_node).height()) - window.scrollY,
                left: $(current_node).offset().left < 400 ? $(current_node).offset().left + 300 : $(current_node).offset().left + 40
            };
        }
        return {};
    };

    return (
        <ModalBase>
            <div className={`${style.hoverModal}${openClass}${closeClass}`}>
                <div ref={ref} className={style.content} style={{ ...offsetStyling() }} onMouseEnter={() => clearTimeout(unhoverTimer.current)}>
                    <div className={`${style.popupArea}`}>
                        <div className={style.articleBanner}>
                            <div className={style.imageWrap}>
                                <Background src={thumbnail_image} size="680x380" />
                            </div>
                        </div>
                        <div className={style.articleBody}>
                            <div className={style.articleDetails}>
                                <div className={style.sectionRow}>
                                    <div className={style.col2}>
                                        <div className={style.buttonRow}>
                                            <ArticleButton type={media_type} url={url} />
                                            {
                                                userProfile.id !== undefined && (
                                                    <ArticleSave id={id} />
                                                )
                                            }
                                        </div>
                                    </div>
                                    <div className={style.col2}>
                                        <div className={style.buttonRow}>
                                            <ArticleButton type="more" url={url} buttonColor="buttonSecondary" />
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div className={style.articleSubDetails}>
                                <div className={style.iconList}>
                                    {
                                        themes.length > 0 && (
                                            <CategoryList item={themes} tag="p" />
                                        )
                                    }
                                    {
                                        categories.length > 0 && (
                                            <div className={style.categoryList}>
                                                <CategoryList item={categories} tag="p" type="category" />
                                            </div>
                                        )
                                    }
                                    <ReadTime time={time_duration} />
                                </div>
                                {
                                    tags.length > 0 && (
                                        <div className={style.iconList}>
                                            <CategoryList item={tags} tag="p" />
                                        </div>
                                    )
                                }
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </ModalBase>
    )
}

export default Hover;